import React, {useState} from 'react';
import {InformationDialog, Link, LinkTextStyle} from 'oui-react';
import * as rateCard from '../store/rateCard';

const Assumptions = () => {
    const [state, setState] = useState({active: false});

    const openModal = () => {
        setState({active: true});
    }

    const closeModal = () => {
        setState({active: false});
    }

    return (
        <div className="">
            <Link textStyle={LinkTextStyle.Default} onClick={openModal}>
                View Assumptions
            </Link>
            <InformationDialog
                isOpen={state.active}
                title="Assumptions"
                closeHandler={closeModal}
                closeText="Close"
                portalClass="assumptionPopup"
            >
                <table className="assumptionTable">
                    <tr>
                        <th>Product</th>
                        <th>OCI Costs</th>
                        <th>AWS Costs</th>
                    </tr>
                    <tr>
                        <td>Compute</td>
                        <td>${rateCard.ociCpu} per CPU hour (Standard.E3.Flex) (reflects CPU + Memory)</td>
                        <td>
                            ${rateCard.awsCompute} per CPR hour (m5 shapes). If a # of cores per instance is
                            requested which AWS does not provide, the smallest available shape with sufficient cores is used
                        </td>
                    </tr>
                    <tr>
                        <td>Standard Block Volume</td>
                        <td>Balanced Performance units at $0.0425 per GB per month
                            (10 Performance units at ${rateCard.ociVpu}/per + ${rateCard.ociBlock} per GB per month
                        </td>
                        <td>General Purpose SSD (gp2) Volumes at ${rateCard.awsBlock} per GB per month</td>
                    </tr>
                    <tr>
                        <td>High-Performance Block Volume</td>
                        <td>
                            High Performance units at $0.0595 per GB per month (20 Performance units at ${rateCard.ociVpu}/per + ${rateCard.ociBlock} per GB per month).
                            Assumes 500 GB volumes (<a href="https://docs.cloud.oracle.com/en-us/iaas/Content/Block/Concepts/blockvolumeperformance.htm" target="_blank" rel="noopener noreferrer">recommended to achieve 35,000 IOPS</a>)
                        </td>
                        <td>
                            Provisioned IOPS SSD (io1) Volumes at $0.125 per GB-month of provisioned storage
                            AND ${rateCard.awsIops} per provisioned IOPS-month. Assumes 500 GB volumes with 35,000 IOPS
                        </td>
                    </tr>
                    <tr>
                        <td>Traffic Egress</td>
                        <td>${rateCard.ociEgress} per GB after 10,240 GBs which come free</td>
                        <td>AWS Data Transfer is tiered pricing that's variable between ${rateCard.awsEgress1} and ${rateCard.awsEgress4} per GB</td>
                    </tr>
                </table>
                <div className="assumptionTable">Calculations reflect 744 hours per month.</div>
                <div className="assumptionTable">AWS costs reflect <a href="https://calculator.aws/#/?nc2=h_ql_pr_calc" target="_blank" rel="noopener noreferrer">AWS Pricing Calculator</a> as of May 1,2020.</div>
            </InformationDialog>
        </div>
    )
}

export default Assumptions;
